import type { sessionStatusEnum } from "./enums";

type SessionStatusLiteral = (typeof sessionStatusEnum.enumValues)[number];

export const SESSION_STATUS = {
  CREATED: "created",
  QUEUED: "queued",
  PROVISIONING: "provisioning",
  RUNNING: "running",
  WAITING_HUMAN: "waiting_human",
  AWAITING_APPROVAL: "awaiting_approval",
  WAITING_EXTERNAL: "waiting_external",
  AWAITING_DEVICE: "awaiting_device",
  DELIVERING: "delivering",
  VERIFYING: "verifying",
  COMPLETED: "completed",
  FAILED: "failed",
  KILLED: "killed",
  ABSTAINED: "abstained",
} as const satisfies {
  [Status in SessionStatusLiteral as Uppercase<Status>]: Status;
};

export type SessionStatus =
  (typeof SESSION_STATUS)[keyof typeof SESSION_STATUS];

/** Shared so the reconciler and realtime agree on when a VM may sleep. */
export const SANDBOX_RETAINING_SESSION_STATUSES: readonly SessionStatus[] = [
  SESSION_STATUS.QUEUED,
  SESSION_STATUS.PROVISIONING,
  SESSION_STATUS.RUNNING,
  SESSION_STATUS.DELIVERING,
  SESSION_STATUS.VERIFYING,
];
